export default __webpack_public_path__ + "static/media/discount.716493e0.png";